import React from 'react';
import { connect } from 'react-redux';
import { SiteAction } from '../../actions/SiteAction';
import { RayForm } from '../../components/common';
import { Translate as t } from '../../config/Translate';
import { EditSaveCancelBar } from '../../components/common/Buttons';
import { useBatchEdit } from '../../hooks/useBatchEdit';

const CUSTOMER_FIELDS = ['customerFirstName', 'customerLastName', 'customerHp', 'customerEmail'];

const toDraft = (site) => {
    const obj = {};
    CUSTOMER_FIELDS.forEach(n => { obj[n] = site?.[n]; });
    return obj;
};

const AdminSiteInfo_Customer = ({ site, UpdateSiteInfo, editable, cancelcallback = null }) => {

    const { draft, editing, saving, errors, formKey, onChange, onEdit, onSave, onCancel } = useBatchEdit({
        source: site,
        toDraft,
        save: (changed) => UpdateSiteInfo(site?._id, changed),
        editable: !!editable,
        entry: 'header',
        onClose: cancelcallback
    });
    const fieldEditable = editing;

    const form_controls = [
        {
            title: "", items: [
                { type: "input", name: "customerFirstName", label: t('common.field.firstName'), val: draft.customerFirstName, isEditable: fieldEditable },
                { type: "input", name: "customerLastName", label: t('common.field.lastName'), val: draft.customerLastName, isEditable: fieldEditable }
            ]
        },
        {
            title: "", items: [
                { type: "tel", name: "customerHp", label: t('common.field.mobile'), val: draft.customerHp, isEditable: fieldEditable },
                { type: "email", name: "customerEmail", label: t('common.field.email'), val: draft.customerEmail, isEditable: fieldEditable },
            ]
        }
    ]

    return (
        <>
            <RayForm
                key={formKey}
                controls={form_controls}
                handleChangeData={onChange}
                errors={errors} />
            <div className="ps-1 pe-1 mb-1">
                <EditSaveCancelBar
                    canEdit={!!editable}
                    editing={editing}
                    onEdit={onEdit}
                    onSave={() => onSave(form_controls)}
                    onCancel={onCancel}
                    saving={saving} />
            </div>
        </>
    );
};

const mapDispatch = dispatch => ({
    UpdateSiteInfo: (_id, data) => dispatch(SiteAction.UpdateSiteInfo(_id, data)),
})
export default connect(null, mapDispatch)(AdminSiteInfo_Customer);